import {
    DataBindingPropertyType,
    IMapContainerControl,
    IViewSets,
    LegendButtons,
    SegmentLabels,
} from '@se/cp.common';
import { DataBinding } from '@se/se.ui.html5';
import { rowProportional } from '../utils/control-grid';
import { AdditionalContentControlType, createAdditionalContent } from './cp-additional-content';

import { CpControl } from './cp-control';


export class CpMapContainerControl extends CpControl {
    readonly controlTypeGroup = 'MapContainer';
    readonly dataBinding?: DataBinding;
    readonly viewsImageBinding?: DataBinding;
    readonly legendImageBinding?: DataBinding;
    readonly isToPrintBinding?: DataBinding;
    readonly additionalContent?: AdditionalContentControlType[];
    readonly legendDataSource: string;
    readonly segmentsDataSource?: string;
    readonly viewSetBinding?: DataBinding;
    readonly viewsSets?: IViewSets = <IViewSets>{};
    readonly readOnly: boolean;
    readonly segmentLabelType: SegmentLabels;
    readonly legendActionsConfiguration: LegendButtons[];
    readonly isHorizontal: boolean;
    readonly isWithTooltip: boolean;
    readonly isWithViewId: boolean;
    readonly fixedViewsColNumber: number | null;
    readonly viewTopLabel: string | null;
    readonly viewTopLabelBinding?: DataBinding;
    readonly viewBottomLabel: string  | null;
    readonly viewBottomLabelBinding?: DataBinding;


    constructor(control: IMapContainerControl, dataBindingContext?: DataBinding) {
        super(control);
        const config = control.config[0];
        this.dataBinding = config.dataBinding ? new DataBinding(config.dataBinding, dataBindingContext) : undefined;
        this.viewsImageBinding = config.viewsImageBinding ? new DataBinding(config.viewsImageBinding, dataBindingContext) : undefined;
        this.viewSetBinding = config.viewSetBinding ? new DataBinding(config.viewSetBinding, dataBindingContext) : undefined;
        this.legendImageBinding = config.legendImageBinding ? new DataBinding(config.legendImageBinding, dataBindingContext) : undefined;
        this.isToPrintBinding = config.isToPrintBinding ? new DataBinding(config.isToPrintBinding, dataBindingContext) : undefined;
        this.legendDataSource = config.legendDataSource ?? null;
        this.viewTopLabelBinding = config.viewTopLabelBinding ? new DataBinding(config.viewTopLabelBinding, dataBindingContext) : undefined;
        this.viewBottomLabelBinding = config.viewBottomLabelBinding ? new DataBinding(config.viewBottomLabelBinding, dataBindingContext) : undefined;;
        this.viewTopLabel = config.viewTopLabel ?? null;
        this.viewBottomLabel = config.viewBottomLabel ?? null;
        this.viewsSets = config.viewsSets ?? undefined;
        this.readOnly = config.readOnly;
        this.isHorizontal = config.isHorizontal ?? false;
        this.segmentLabelType = config.segmentLabelType ?? SegmentLabels.none;
        this.legendActionsConfiguration = config.legendActionsConfiguration ?? [];
        this.isWithTooltip = config.isWithTooltip ?? true;
        this.isWithViewId = config.isWithViewId ?? false;
        this.segmentsDataSource = config.segmentsDataSource ?? null;
        this.fixedViewsColNumber = config.fixedViewsColNumber ?? null;
        this.additionalContent = createAdditionalContent(control.additionalContent ?? [], dataBindingContext);
    }

    canAlignToBottom() {
        return true;
    }

    getHeightHint() {
        return rowProportional(this.rowSpan);
    }
}
